import React from 'react'
import styled from 'styled-components'
import { TableCell } from './TableCell'
import column from './interface'

interface TableRowProps {
  key: string
  row: {
    [key: string]: number | string | boolean
  }
  columns: column[]
  accessibilityMode: boolean
}

export const TableRow: React.FC<TableRowProps> = ({ row, columns, accessibilityMode }) => {
  const idProp = row.id ? { id: String(row.id) } : {}
  return (
    <tr className="cb-white-bg" {...idProp}>
      {columns.map((column, index) => (
        <TableCell
          key={column.field}
          row={row}
          column={column}
          rowIndex={index}
          accessibilityMode={accessibilityMode}
        />
      ))}
    </tr>
  )
}
